import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
    selector: 'app-aarni-group',
    templateUrl: './aarni-group.component.html',
    styleUrls: ['./aarni-group.component.scss']
})
export class AarniGroupComponent implements OnInit {
    pageTitle: any;
    activeIndex: number | null = null;
    searchForm: FormGroup = new FormGroup({});
    filteredFacultyList: any[] = [];
    selectedPdf: SafeResourceUrl | null = null;
    approvals = [
        {
            title: 'Approved by University Grants Commission (UGC)',
            image: 'assets/img/approvals/ugc-2f.webp',
            pdf: 'assets/img/approvals/ugc-2f.pdf',
        },
        {
            title: 'Recognized by the Government of Himachal Pradesh',
            image: 'assets/img/approvals/hp-government.webp',
            pdf: 'assets/img/approvals/hp-govt-approved.pdf',
        },
        {
            title: 'Approved by Pharmacy Council of India (PCI)',
            image: 'assets/img/approvals/pci-approved.webp',
            pdf: 'assets/img/approvals/affiliation.pdf',
        },
        {
            title: 'Explore Our Career-Focused B.Sc. Programs',
            image: 'assets/img/approvals/bsc-program.webp',
            pdf: 'assets/img/approvals/bscapprol.pdf',
        },
    ];

    coreValues: any[] = [
        {
            heading:
                'Integrity',
            content: `
                       <p class="text-gray-600">
                      For a meaningful education and ethical leadership, integrity plays an important role. At ARNI University, we believe and promote transparency, honesty, and accountability in every aspect of learning and administration. We educate and encourage our students to uphold academic and personal integrity in their actions, ensuring that they grow not only professionally but also become responsible and trustworthy individuals. We lead by example, cultivating a campus culture rooted in truth, fairness, and mutual respect.</p>
                 <!--      <ul class='list-disc px-8'>
                           <li class="my-2">
                                <p class="font-bold">Ethical Standards</p>
                                 <p class="mx-2">We are committed to upholding the highest personal, professional, and ethical standards in everything we do. Whether in teaching, research, leadership, or service, we act with honesty, courage, and trust. These standards ensure that our academic pursuits are not only successful but are also rooted in moral responsibility and respect for others. Ethical behavior is embedded into our academic fabric and is expected from every individual associated with the university.</p>
                           </li>
                            <li class="my-2">
                                <p class="font-bold">Transparency and Fairness</p>
                                <p class="mx-2">Transparency and fairness are essential to creating a culture of openness and accountability. At Arni University, we promote consistency in our actions and decisions by ensuring clear communication, unbiased processes, and equal opportunities for all. We believe that fairness fosters trust, and transparency empowers individuals—contributing to a more cohesive, inclusive, and democratic academic environment.</p>
                           </li>
                       </ul>-->`
        },
        {
            heading:
                'Leadership',
            content: `
                       <p class="text-gray-600">For us, the word leadership goes beyond titles – It is about mentoring individuals and empowering them to take initiatives, inspire others, and drive positive changes among the students. We emphasize leadership skills in our students by promoting critical thinking skills, better decision-making, and social responsibility. From classroom learning to extracurricular engagements and real-world experiences, we develop future leaders who are not just professionals, but capable to guide and lead teams, making an impactful effect.</p>
                     <!--  <ul class='list-disc px-8'>
                           <li class="my-2">
                                <p class="font-bold">Governance</p>
                                 <p class="mx-2">Our governance framework reflects our unwavering commitment to ethical conduct and value-based decision-making. Every action—whether academic, administrative, or strategic—is guided by principles of integrity, fairness, and social responsibility. This ensures that transparency, inclusivity, and accountability remain central to how the university is managed and how trust is built with all stakeholders.</p>
                           </li>
                            <li class="my-2">
                                <p class="font-bold">Leadership Development</p>
                                <p class="mx-2">We are dedicated to cultivating leadership qualities among students, faculty, and staff. Through mentorship, capacity-building workshops, and participative initiatives, we empower individuals to lead with purpose and authenticity. Our goal is to foster value-based leadership that influences positive change within the university and in the wider world. We believe that when individuals are encouraged to lead ethically and collaboratively, they become catalysts for innovation, unity, and progress.
                            </p>
                           </li>
                       </ul>-->`
        },
        {
            heading: 'Diversity',
            content: `
        <p class="text-gray-600">
We are not just offering a diverse range of academic courses, we celebrate diversity as a source of strength and innovation. We at ARNI University are always welcoming students, faculty, and staff from varied backgrounds, cultures, and perspectives. We are committed to building an inclusive environment where everyone feels seen, heard, and respected. Our diverse campus promotes open dialogue, multicultural learning, and global awareness—preparing students to thrive in an interconnected world.
        </p>
      <!--  <ul class='list-disc px-8'>
            <li class="my-2">
                <p class="font-bold">Equity</p>
                <p class="mx-2">
                    Arni University stands firm in its belief that true inclusion begins with equity. We are committed to treating every individual with dignity and respect, regardless of their social, cultural, economic, or regional background. Our policies and practices are designed to offer equal access to resources, opportunities, and support, ensuring that no one is left behind on the path to success.
                </p>
            </li>
            <li class="my-2">
                <p class="font-bold">Cross-cultural Environment</p>
                <p class="mx-2">
                    We actively cultivate a cross-cultural learning atmosphere where collaborative thinking and intercultural exchange are encouraged both inside and outside the classroom. Our students, faculty members, and staff come together as one cohesive community—sharing knowledge, perspectives, and experiences to achieve the shared vision and mission of the University. Through group activities, events, and inclusive academic practices, we promote cultural sensitivity, global awareness, and a sense of belonging for all.
                </p>
            </li>
        </ul>-->
    `
        },
        {
            heading: 'Community',
            content: `
    <p class="text-gray-600">
A sense of community is at the heart of the ARNI experience. We are more than an educational institution—we are a supportive, dynamic, and collaborative family. Whether through academic collaboration, cultural events, social responsibility programs, or alumni engagement, we nurture connections that last a lifetime. Our community spirit fuels a culture of belonging, encouragement, and shared success.
    </p>

    <!--<ul class='list-disc px-8 mt-4'>
      <li class="my-2">
        <p class="font-bold">Extension Activities</p>
        <p class="mx-2">
          Arni University actively engages in a wide range of extension and outreach programs aimed at addressing local and regional needs, particularly in the areas of education, health, and sustainable development. These initiatives help bridge the gap between academia and community, allowing students and faculty to apply their knowledge and skills for the betterment of society.
        </p>
      </li>

      <li class="my-2">
        <p class="font-bold">Social Responsibility</p>
        <p class="mx-2">
          Through community service, awareness campaigns, and volunteering opportunities, we instill a strong sense of social responsibility in our learners. We encourage them to be empathetic leaders and active citizens who contribute to building a more equitable and compassionate world.
        </p>
      </li>

      <li class="my-2">
        <p class="font-bold">Inclusive Participation</p>
        <p class="mx-2">
          The university fosters inclusive participation by engaging students from diverse backgrounds in collaborative efforts that promote unity, teamwork, and respect for differences. Whether it’s organizing blood donation drives, environmental initiatives, or rural development programs, every voice is valued and every effort matters.
        </p>
      </li>
    </ul>-->
  `
        }

    ];
    missionAndVision: any[] = [
        {
            heading:
                'Transformative educational experience',
            content: `
                       <p class="text-gray-600 mx-8">
                       To serve the society by being a global University of higher learning in pursuit of academic excellence, innovation and nurturing entrepreneurship.</p>
                       <ul class='list-disc px-8'>
                           <li class="my-2">
                                 <p class="mx-2">Developing deep disciplinary knowledge, problem solving ability, leadership, communication and interpersonal skills.</p>
                           </li>
                            <li class="my-2">
                                <p class="mx-2">Strengthening the flexible credit-based system for interdisciplinary learning to enrich academic experience.</p>
                           </li>
                              <li class="my-2">
                                 <p class="mx-2">Ensuring student participation in career enhancement activities through exchange programs, student enterprise, volunteering and work-based learning.</p>
                           </li>
                            <li class="my-2">
                                <p class="mx-2">Focusing on strong mentor-mentee relationships which enhance overall personality of the students and equip them to face future challenges.
                                </p>
                           </li>
                       </ul>`
        },
        {
            heading:
                'Enrichment by educational initiatives that encourage global outlook',
            content: `
                       <p class="text-gray-600 mx-8">We believe in cultivating a culture of genuine sincerity, trust and collaboration at all levels through value-based leadership</p>
                       <ul class='list-disc px-8'>
                           <li class="my-2">
                                 <p class="mx-2">To create an environment where students and employees of diverse backgrounds live, study, learn, and socialize together.</p>
                           </li>
                            <li class="my-2">
                                <p class="font-bold">To encourage pursuit of knowledge and support the development of curricula from global perspective. </p>
                           </li>
                              <li class="my-2">
                                <p class="font-bold">To invest in faculty development to upskill them in designing and developing curricula, pursuing research, and offering experiential learning. </p>
                           </li>
                              <li class="my-2">
                                <p class="font-bold">To strengthen the student-welfare activities, academic counselling and administrative support services that contribute to holistic development of today’s students as future responsible citizens. </p>
                           </li>
                       </ul>`
        },
        {
            heading: 'Develop research, support disruptive innovations and accelerate entrepreneurship',
            content: `
                       <ul class='list-disc px-8'>
                           <li class="my-2">
                                 <p class="mx-2">Create high-quality and flexible collaborative research space and culture that enable and promote knowledge creation.</p>
                           </li>
                            <li class="my-2">
                                <p class="mx-2">Encourage involvement of students in research.</p>
                           </li>
                               <li class="my-2">
                                 <p class="mx-2">Strengthen entrepreneurial and innovation culture among students and employees.</p>
                           </li>
                            <li class="my-2">
                                <p class="mx-2">Create mechanisms to stimulate meaningful bottom-up and top-down collaborations among faculty, staff and students with diverse disciplinary backgrounds.</p>
                           </li>
                               <li class="my-2">
                                 <p class="mx-2">Explore opportunities to apply knowledge to promote private and public partnership.</p>
                           </li>
                            <li class="my-2">
                                <p class="mx-2">Enable students to explore and acquire leadership qualities.</p>
                           </li>
                       </ul>`
        },
        {
            heading:
                'Seeking beyond boundaries',
            content: `
                       <p class="text-gray-600 mx-8">We serve our society while respecting rights of everybody</p>
                       <ul class='list-disc px-8'>
                           <li class="my-2">
                                 <p class="mx-2">Promoting our global communities as active ambassadors of higher education.</p>
                           </li>
                            <li class="my-2">
                                 <p class="mx-2">Leveraging the alumni network to assist development of innovative curricula and research initiatives that will better prepare our students to become global citizens.</p>
                           </li>
                            <li class="my-2">
                                 <p class="mx-2">Establishing and maintaining close cooperation among academia and private and public sector industries by contributing through academic findings and developments.</p>
                           </li>
                           <li class="my-2">
                                 <p class="mx-2">To empower each student to discover their individual potential by providing opportunities for collaborative-learning beyond the classroom, in the broader community - across the diverse spectrum of disciplines.</p>
                           </li>
                       </ul>`
        }
    ];
    selectedTab = 'all';
    facultyTabs = [
        {label: 'All', key: 'all'},
        {label: 'Dean', key: 'dean'},
        {label: 'HOD', key: 'hod'},
        {label: 'Assistant Professor', key: 'assistant_professor'},
        {label: 'Associate Professor', key: 'associate_professor'},
        {label: 'Lecturer / Tutor', key: 'lecturer_tutor'},
        {label: 'Academic Associate', key: 'academic_associate'},
        {label: 'Teaching Assistant', key: 'teaching_assistant'},
    ];
    facultyData = {
        all: [
            {
                name: 'Prof. (Dr.) R.K. Kaundal',
                designation: 'Dean, Academic Affairs',
                image: 'assets/img/dean-as-per-schools/dean-of-academic-affairs-arni.webp',
            },
            {
                name: 'Dr. Rakesh Kumar',
                designation: 'M.A. M Phil , PhD , PGDTE(CIEFL), Post-Colonial Literature and Cultural Studies, Professor of English',
                image: 'assets/img/hods-as-per-schools/dr-rakesh-kumar-ma-mphil-phd.jpg',
            },
            {
                name: 'Prof. (Dr.) Brijesh Tewari',
                designation: 'Dean, Arni School of Art & Humanities',
                image: 'assets/img/dean-as-per-schools/dr-brijesh-tiwari-arni-school-of-arts-and-humanities.png',
            },
            {
                name: 'Dr. Gurvinder Singh',
                designation: 'Dean, Arni School of Technology',
                image: 'assets/img/dean-as-per-schools/dr-gurvinder-singh-arni-school-of-technology.png',
            },
            {
                name: 'Dr. Neeraj Bhandari',
                designation: 'Principal, Arni School of Pharmacy',
                image: 'assets/img/dean-as-per-schools/dr-neeraj-bhandari-arni-school-of-pharmacy.png',
            },
            {
                name: 'Dr. Samiksha Sharma',
                designation: 'Head of Department/ Assistant Professor - Arni School of Arts and Humanities',
                image: 'assets/img/hods-as-per-schools/dr-samiksha-sharma-arni-school-of-arts-and-humanities.png',
            },
            {
                name: 'Dr. Saurabh Sharma',
                designation: 'Head of Department, Department of Chemistry, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/hods-as-per-schools/dr-saurabh-sharma-assistant-professor-department-of-chemistry.png',
            },
            {
                name: 'Dr. Ashish Kumar Sharma',
                designation: 'Associate Professor, Head of Department, Mathematics Department',
                incharge: 'Incharge and Deputy Dean R & D',
                image: 'assets/img/hods-as-per-schools/dr-ashish-kumar-sharma-department-of-mathematics.png',
            },
            {
                name: 'Dr. Irshad Ahmad Sofi',
                designation: 'Head of Department, Business Management and Commerce',
                image: 'assets/img/hods-as-per-schools/dr-irshad-ahmad-sofi-arni-school-of-business-management-and-commerce.png',
            },
            {
                name: 'Dr. Neha Salaria',
                designation: 'Head of Institute - Arni School of Basic Science and Biotechnology',
                image: 'assets/img/hods-as-per-schools/neha-salaria.png',
            },
            {
                name: 'Dr. Sharad Kumar Tripathi',
                designation: 'Head of Department, Life Sciences and Agriculture',
                image: 'assets/img/hods-as-per-schools/dr-sharad-kumar-tripathi-arni-school-of-life-sciences-and-agriculture.png',
            },
            {
                name: 'Dr. Sudhir Kumar Pal',
                designation: 'Head of Department, School of Law',
                image: 'assets/img/hods-as-per-schools/dr-sudhir-kumar-pal-arni-school-of-law.png',
            },
            {
                name: 'Mr. Aman Sharma',
                designation: 'Assistant Professor, Arni School of Pharmacy',
                image: 'assets/img/assistant-professor/aman-sharma-arni-school-of-pharmacy.png',
            },
            {
                name: 'Dr. Amita',
                designation: 'Assistant Professor, (Physiotherapy Department) Arni School of Allied Health Sciences',
                image: 'assets/img/assistant-professor/dr-amita-physiotherapy-department-arni-school-of-allied-health-sciences.png',
            },
            {
                name: 'Ms. Jaspreet Kaur',
                designation: 'Teaching Assistant, CSA',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/ms-jaspreet-kaur-assistant-professor-csa.webp',
            },
            {
                name: 'Dr. Navjyoti Gupta',
                designation: 'Assistant Professor, Physiotherapy',
                image: 'assets/img/assistant-professor/dr-navjyoti-gupta-assistant-professor-physiotherapy.png',
            },
            {
                name: 'Dr. Nikhil',
                designation: 'Assistant Professor, Arni School of Agriculture',
                image: 'assets/img/assistant-professor/dr-nikhil-arni-school-of-agriculture-assistant-professor.png',
            },
            {
                name: 'Dr. Samiksha Sharma',
                designation: 'Assistant Professor, Arni School of Arts and Humanities',
                image: 'assets/img/assistant-professor/dr-samiksha-sharma-assistant-professor-arni-school-of-arts-and-humanities.png',
            },
            {
                name: 'Dr. Saurabh Sharma',
                designation: 'Assistant Professor, Department of Chemistry, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/dr-saurabh-sharma-assistant-professor-department-of-chemistry.png',
            },
            {
                name: 'Dr. Sunita',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/dr-sunita-arni-school-of-technology-csa.png',
            },
            {
                name: 'Mr. Ashish Parashar',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-ashish-parashar-arni-school-of-management-and-commerce.png',
            },
            {
                name: 'Mr. Dalvir Singh',
                designation: 'Assistant Professor, (Civil Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-dalvir-singh-arni-school-of-technology-civil-engineering.png',
            },
            {
                name: 'Mr. Harit Singh',
                designation: 'Assistant Professor, (Electrical Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-harit-singh-arni-school-of-technology-electrical-engineering.png',
            },
            {
                name: 'Mr. Manish Kumar',
                designation: 'Assistant Professor, Department of Chemistry, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/mr-manish-kumar-assistant-professor-department-of-chemistry.png',
            },
            {
                name: 'Mr. Manu Mahajan',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-manu-mahajan-arni-school-of-management-and-commerce-assistant-professor.png',
            },
            {
                name: 'Mr. Mohammad Rafiq Sheikh',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-m-rafiq-sheikh-arni-school-management-and-commerce.png',
            },
            {
                name: 'Mr. Narendra Pal',
                designation: 'Assistant Professor, Arni School of Education and Sports',
                image: 'assets/img/assistant-professor/mr-narendra-pal-arni-school-of-education-and-sports.png',
            },
            {
                name: 'Mr. Rahul Kumar',
                designation: 'Assistant Professor, Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-rahul-kumar-assistant-professor-csa-arni-school-of-technology.png',
            },
            {
                name: 'Mr. Ravan Kumar',
                designation: 'Assistant Professor, Arni School of Commerce and Management',
                image: 'assets/img/assistant-professor/mr-ravan-kumar-arni-school-of-commerce-and-management-assistant-professor.png',
            },
            {
                name: 'Mr. Rishav',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-rishav-assistant-professor-arni-school-of-technology-csa.png',
            },
            {
                name: 'Mr. Rohit Kumar',
                designation: 'Assistant Professor, (Civil Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-rohit-kumar-assistant-professor-civil-engineering.png',
            },
            {
                name: 'Mr. Rohit Pathania',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-rohit-pathania-arni-school-of-management-and-commerce-assistant-professor.png',
            },
            {
                name: 'Mr. Shashi Karel',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-shashi-karel-assistant-professor-management-and-commerce.png',
            },
            {
                name: 'Mr. Sukhvinder Singh',
                designation: 'Assistant Professor, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/mr-sukhvinder-singh-assistant-professor-life-sciences.png',
            },
            {
                name: 'Mr. Surjeet Singh',
                designation: 'Assistant Professor, (Mechanical Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-surjeet-singh-arni-school-of-technology-mechanical-engineering.png',
            },
            {
                name: 'Mr. Vinay',
                designation: 'Assistant Professor, (CSE) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-vinay-assistant-professor-arni-school-of-technology-cse.png',
            },
            {
                name: 'Ms. Deepika',
                designation: 'Assistant Professor, (CSE) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-deepika-assistant-professor-cse-arni-school-of-technology.png',
            },
            {
                name: 'Ms Mehvish Showkat',
                designation: 'Assistant Professor,LLM (Constitutional Law) Arni School of Law',
                image: 'assets/img/school-wise-faculties/arni-school-of-law/mehvish-showkat-assistant-professor-law.jpeg',
            },
            {
                name: 'Ms. Geetanjali',
                designation: 'Assistant Professor, (Department of Radiology) Arni School of Allied Health Sciences',
                image: 'assets/img/assistant-professor/ms-geetanjali-arni-school-of-allied-health-sciences-department-of-radiology.png',
            },
            {
                name: 'Ms. Minakshi Thakur',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-minakshi-thakur-arni-school-of-technology-csa.png',
            },
            {
                name: 'Ms. Neha Rani',
                designation: 'Assistant Professor, (CSE) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-neha-rani-arni-school-of-technology-cse.png',
            },
            {
                name: 'Ms. Nitika',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-nitika-arni-school-of-technology-csa.png',
            },
            {
                name: 'Ms. Parikalpana Dhiman',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-parikalpana-dhiman-arni-school-of-business-management-and-commerce.png',
            },
            {
                name: 'Ms. Preeti Bhandari',
                designation: 'Assistant Professor, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/ms-preeti-bhandari-assistant-professor-life-sciences.png',
            },
            {
                name: 'Ms. Ranjana Kumari',
                designation: 'Assistant Professor, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/ms-ranjana-kumari-assistant-professor-life-sciences.png',
            },
            {
                name: 'Ms. Shalini Sharma',
                designation: 'Assistant Professor, Arni School of Allied Health Sciences',
                image: 'assets/img/assistant-professor/ms-shalini-sharma-arni-school-of-allied-health-sciences.png',
            },
            {
                name: 'Ms. Sunita',
                designation: 'Assistant Professor, Mathematics Department',
                image: 'assets/img/assistant-professor/ms-sunita-assistant-professor-mathematics-department.png',
            },
            {
                name: 'Mr. Naresh Kumar',
                designation: 'Assistant Professor, (Electrical Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/naresh-kumar-arni-school-of-technology-electrical-engineering.png',
            },
            {
                name: 'Mr. Rahul Kumar',
                designation: 'Assistant Professor, Arni School of Law',
                image: 'assets/img/assistant-professor/rahul-kumar-arni-school-of-law-assistant-professor.png',
            },
            {
                name: 'Mr. Raies Ahmad Thoker',
                designation: 'Assistant Professor, (Department of Anesthesia and Operation Theatre) Arni School of Allied Health Sciences',
                image: 'assets/img/assistant-professor/raies-ahmed-thoker-arni-school-of-allied-health-sciences-department-of-anesthesia-and-operation-theatre-technology.png',
            },
            {
                name: 'Dr. Raman',
                designation: 'Assistant Professor, Arni School of Law',
                image: 'assets/img/assistant-professor/raman-arni-school-of-law-assistant-professor.png',
            },
            {
                name: 'Mr. Sameer Ahmed Mir',
                designation: 'Assistant Professor, (MLT Department) Arni School of Technology',
                image: 'assets/img/assistant-professor/sameer-ahmed-mir-arni-school-of-allied-health-sciences-department-mlt.png',
            },
            {
                name: 'Mr. Sandeep Kumar',
                designation: 'Assistant Professor, Arni School of Hotel Management and Tourism',
                image: 'assets/img/assistant-professor/sandeep-kumar-assistant-professor-hotel-manegement-and-tourism.png',
            },
            {
                name: 'Tahira Salaam',
                designation: 'Assistant Professor, Department of OT/AT',
                image: 'assets/img/assistant-professor/tahira-salaam-department-of-ot-at.png',
            },
            {
                name: 'Chandani Vaishnav',
                designation: 'Lecturer, Arni School of Hotel Management and Tourism',
                image: 'assets/img/lecturer/chandani-vaishnav-lecturer-hotel-management-and-tourism.png',
            },
            {
                name: 'Mr. Ashish Kumar',
                designation: 'Academic Associate , (Mechanical Engineering) Arni School of Technology',
                image: 'assets/img/academic-associate/ashish-kumar-arni-school-of-technology-mechanical-engineering.png',
            },
            {
                name: 'Ms. Manjubala',
                designation: 'Academic Associate , Department of Mathematics, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/academic-associate/ms-manjubala-mathematics-department.png',
            },
            {
                name: 'Sameer Ahmad Mir',
                designation: 'Assistant Professor, MLT (Allied Health Sciences)',
                image: 'assets/img/assistant-professor/sameer-ahmad-mir-assistant-professor-mlt-allied-health-sciences.jpeg',
            },
            {
                name: 'Anayat Ali Dar',
                designation: 'Assistant Professor, OT/AT (Allied Health Sciences)',
                image: 'assets/img/assistant-professor/anayat-ali-dar-assistant-professor-ot-at.jpeg',
            },
            {
                name: ' Dr. Navjyoti Gupta',
                designation: 'Assistant Professor, Physiotherapy (Allied Health Sciences)',
                image: 'assets/img/assistant-professor/navjyoti-gupta-assistant-professor-physiotherapy.jpeg',
            },
            {
                name: 'Anjali',
                designation: 'Assistant Professor, Pharmacy',
                image: 'assets/img/assistant-professor/anjali-assistant-professor-pharmacy.jpeg',
            },
            {
                name: 'Deepika',
                designation: 'Assistant Professor, Computer Science & Engineering',
                image: 'assets/img/assistant-professor/deepika-assistant-professor-cse.jpeg',
            },
            {
                name: 'Dr. Waseem Qayoom Kachroo',
                designation: 'Assistant Professor, Psychology Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/dr-waseem-qayoom-kachroo-assistant-professor-psychology.png',
            },
            {
                name: 'Mrs. Anjna Devi',
                designation: 'Assistant Professor, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/mrs-anjna-devi-assistant-professor.png',
            },
            {
                name: 'Mrs. Samiksha Sharma',
                designation: 'Assistant Professor, English Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/mrs-samiksha-sharma-english-assistant-professor.png',
            },
            {
                name: 'Ms. Shavnam Sharma',
                designation: 'Lecturer, Fashion Design Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/ms-shavnam-sharma-fashion-design-lecturer.png',
            },
            {
                name: 'Mrs Shama Rani',
                designation: 'Lecturer, Fashion Design Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/mrs-shama-rani-lecturer-fashion-design.png',
            },
            {
                name: 'Ms. Mamta Devi',
                designation: 'Teaching Assistant, Hindi Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/ms-mamta-devi-teaching-assistant.png',
            },
            {
                name: 'Ankush Kumar',
                designation: 'Assistant Professor, ARNI School of Pharmacy',
                image: 'assets/img/school-wise-faculties/arni-school-of-pharmacy/ankush-kumar-assistant-professor.png',
            },
            {
                name: 'Ankush Sharma',
                designation: 'Assistant Professor, ARNI School of Pharmacy',
                image: 'assets/img/school-wise-faculties/arni-school-of-pharmacy/ankush-sharma-assistant-professor.png',
            },
            {
                name: 'Ms. Juna Bibi',
                designation: 'Teaching Assistant, History Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/ms-juna-bibi-history-teaching-assistant.png',
            },
            {
                name: 'Ms. Sunita',
                designation: 'Assistant Professor, Mathematics Department, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/school-wise-faculties/arni-school-of-basic-sciences/ms-sunita-assistant-professor-mathematics.png',
            },
            {
                name: 'Ms. Pallavi',
                designation: 'Assistant Professor , Mathematics Department, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/school-wise-faculties/arni-school-of-basic-sciences/ms-pallavi-assistant-professor-mathematics.png',
            },
            {
                name: 'Mr. Rahul Kumar',
                designation: 'Assistant Professor, CSA, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/mr-rahul-kumar-assistant-professor-csa.png',
            },
            {
                name: 'Mr. Rishav',
                designation: 'Assistant Professor, CSA, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/rishav-assistant-professor-csa.png',
            },
            {
                name: 'Harjit Singh',
                designation: 'Assistant Professor, Electrical Engineering, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/harjit-singh-assistant-professor-electrical-engineering.png',
            },
            {
                name: 'Surjit Singh',
                designation: 'Assistant Professor, Mechanical Engineering, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/surjit-singh-assistant-professor-mechanical-engineering.png',
            },
            {
                name: 'Rohit Kumar',
                designation: 'Assistant Professor, Civil Engineering, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/rohit-kumar-civil-engineering-assistant-professor.png',
            },
            {
                name: 'Naresh Kumar',
                designation: 'Assistant Professor, Electrical Engineering, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/naresh-kumar-assistant-professor-ee.png',
            },
        ],
        dean: [
            {
                name: 'Prof. (Dr.) R.K. Kaundal',
                designation: 'Dean, Academic Affairs',
                image: 'assets/img/dean-as-per-schools/dean-of-academic-affairs-arni.webp',
            },
            {
                name: 'Prof. (Dr.) Brijesh Tewari',
                designation: 'Dean, Arni School of Art & Humanities',
                image: 'assets/img/dean-as-per-schools/dr-brijesh-tiwari-arni-school-of-arts-and-humanities.png',
            },
            {
                name: 'Dr. Gurvinder Singh',
                designation: 'Dean, Arni School of Technology',
                image: 'assets/img/dean-as-per-schools/dr-gurvinder-singh-arni-school-of-technology.png',
            },
        ],
        hod: [
            {
                name: 'Dr. Samiksha Sharma',
                designation: 'Head of Department/ Assistant Professor - Arni School of Arts and Humanities',
                image: 'assets/img/hods-as-per-schools/dr-samiksha-sharma-arni-school-of-arts-and-humanities.png',
            },
            {
                name: 'Dr. Saurabh Sharma',
                designation: 'Head of Department, Department of Chemistry, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/hods-as-per-schools/dr-saurabh-sharma-assistant-professor-department-of-chemistry.png',
            },
            {
                name: 'Dr. Ashish Kumar Sharma',
                designation: 'Head of Department, Mathematics Department, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/hods-as-per-schools/dr-ashish-kumar-sharma-department-of-mathematics.png',
            },
            {
                name: 'Dr. Irshad Ahmad Sofi',
                designation: 'Head of Department, Business Management and Commerce',
                image: 'assets/img/hods-as-per-schools/dr-irshad-ahmad-sofi-arni-school-of-business-management-and-commerce.png',
            },
            {
                name: 'Dr. Sharad Kumar Tripathi',
                designation: 'Head of Department, Life Sciences and Agriculture',
                image: 'assets/img/hods-as-per-schools/dr-sharad-kumar-tripathi-arni-school-of-life-sciences-and-agriculture.png',
            },
            {
                name: 'Dr. Sudhir Kumar Pal',
                designation: 'Head of Department, School of Law',
                image: 'assets/img/hods-as-per-schools/dr-sudhir-kumar-pal-arni-school-of-law.png',
            },
        ],
        assistant_professor: [
            {
                name: 'Mr. Aman Sharma',
                designation: 'Assistant Professor, Arni School of Pharmacy',
                image: 'assets/img/assistant-professor/aman-sharma-arni-school-of-pharmacy.png',
            },
            {
                name: 'Dr. Amita',
                designation: 'Assistant Professor, (Physiotherapy Department) Arni School of Allied Health Sciences',
                image: 'assets/img/assistant-professor/dr-amita-physiotherapy-department-arni-school-of-allied-health-sciences.png',
            },
            {
                name: 'Dr. Navjyoti Gupta',
                designation: 'Assistant Professor, Physiotherapy',
                image: 'assets/img/assistant-professor/dr-navjyoti-gupta-assistant-professor-physiotherapy.png',
            },
            {
                name: 'Dr. Nikhil',
                designation: 'Assistant Professor, Arni School of Agriculture',
                image: 'assets/img/assistant-professor/dr-nikhil-arni-school-of-agriculture-assistant-professor.png',
            },
            {
                name: 'Dr. Samiksha Sharma',
                designation: 'Assistant Professor, Arni School of Arts and Humanities',
                image: 'assets/img/assistant-professor/dr-samiksha-sharma-assistant-professor-arni-school-of-arts-and-humanities.png',
            },
            {
                name: 'Dr. Saurabh Sharma',
                designation: 'Assistant Professor, Department of Chemistry',
                image: 'assets/img/assistant-professor/dr-saurabh-sharma-assistant-professor-department-of-chemistry.png',
            },
            {
                name: 'Dr. Sunita',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/dr-sunita-arni-school-of-technology-csa.png',
            },
            {
                name: 'Mr. Ashish Parashar',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-ashish-parashar-arni-school-of-management-and-commerce.png',
            },
            {
                name: 'Mr. Dalvir Singh',
                designation: 'Assistant Professor, (Civil Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-dalvir-singh-arni-school-of-technology-civil-engineering.png',
            },
            {
                name: 'Ms Mehvish Showkat',
                designation: 'Assistant Professor, LLM (Constitutional Law) Arni School of Law',
                image: 'assets/img/school-wise-faculties/arni-school-of-law/mehvish-showkat-assistant-professor-law.jpeg',
            },
            {
                name: 'Dr. Waseem Qayoom Kachroo',
                designation: 'Assistant Professor, Psychology Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/dr-waseem-qayoom-kachroo-assistant-professor-psychology.png',
            },
            {
                name: 'Mr. Harit Singh',
                designation: 'Assistant Professor, (Electrical Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-harit-singh-arni-school-of-technology-electrical-engineering.png',
            },
            {
                name: 'Mr. Manish Kumar',
                designation: 'Assistant Professor, Department of Chemistry, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/mr-manish-kumar-assistant-professor-department-of-chemistry.png',
            },
            {
                name: 'Mr. Manu Mahajan',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-manu-mahajan-arni-school-of-management-and-commerce-assistant-professor.png',
            },
            {
                name: 'Mr. Mohammad Rafiq Sheikh',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-m-rafiq-sheikh-arni-school-management-and-commerce.png',
            },
            {
                name: 'Mr. Narendra Pal',
                designation: 'Assistant Professor, Arni School of Education and Sports',
                image: 'assets/img/assistant-professor/mr-narendra-pal-arni-school-of-education-and-sports.png',
            },
            {
                name: 'Mr. Rahul Kumar',
                designation: 'Assistant Professor, Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-rahul-kumar-assistant-professor-csa-arni-school-of-technology.png',
            },
            {
                name: 'Mr. Ravan Kumar',
                designation: 'Assistant Professor, Arni School of Commerce and Management',
                image: 'assets/img/assistant-professor/mr-ravan-kumar-arni-school-of-commerce-and-management-assistant-professor.png',
            },
            {
                name: 'Mr. Rishav',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-rishav-assistant-professor-arni-school-of-technology-csa.png',
            },
            {
                name: 'Mr. Rohit Kumar',
                designation: 'Assistant Professor, (Civil Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-rohit-kumar-assistant-professor-civil-engineering.png',
            },
            {
                name: 'Mr. Rohit Pathania',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-rohit-pathania-arni-school-of-management-and-commerce-assistant-professor.png',
            },
            {
                name: 'Mr. Shashi Karel',
                designation: 'Assistant Professor, Arni School of Management and Commerce',
                image: 'assets/img/assistant-professor/mr-shashi-karel-assistant-professor-management-and-commerce.png',
            },
            {
                name: 'Mr. Sukhvinder Singh',
                designation: 'Assistant Professor, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/mr-sukhvinder-singh-assistant-professor-life-sciences.png',
            },
            {
                name: 'Mr. Surjeet Singh',
                designation: 'Assistant Professor, (Mechanical Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-surjeet-singh-arni-school-of-technology-mechanical-engineering.png',
            },
            {
                name: 'Mr. Vinay',
                designation: 'Assistant Professor, (CSE) Arni School of Technology',
                image: 'assets/img/assistant-professor/mr-vinay-assistant-professor-arni-school-of-technology-cse.png',
            },
            {
                name: 'Ms. Deepika',
                designation: 'Assistant Professor, (CSE) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-deepika-assistant-professor-cse-arni-school-of-technology.png',
            },
            {
                name: 'Ms. Geetanjali',
                designation: 'Assistant Professor, (Department of Radiology) Arni School of Allied Health Sciences',
                image: 'assets/img/assistant-professor/ms-geetanjali-arni-school-of-allied-health-sciences-department-of-radiology.png',
            },
            {
                name: 'Ms. Minakshi Thakur',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-minakshi-thakur-arni-school-of-technology-csa.png',
            },
            {
                name: 'Ms. Neha Rani',
                designation: 'Assistant Professor, (CSE) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-neha-rani-arni-school-of-technology-cse.png',
            },
            {
                name: 'Ms. Nitika',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-nitika-arni-school-of-technology-csa.png',
            },
            {
                name: 'Ms. Parikalpana Dhiman',
                designation: 'Assistant Professor, (CSA) Arni School of Technology',
                image: 'assets/img/assistant-professor/ms-parikalpana-dhiman-arni-school-of-business-management-and-commerce.png',
            },
            {
                name: 'Ms. Preeti Bhandari',
                designation: 'Assistant Professor, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/ms-preeti-bhandari-assistant-professor-life-sciences.png',
            },
            {
                name: 'Ms. Ranjana Kumari',
                designation: 'Assistant Professor, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/assistant-professor/ms-ranjana-kumari-assistant-professor-life-sciences.png',
            },
            {
                name: 'Ms. Shalini Sharma',
                designation: 'Assistant Professor, Arni School of Allied Health Sciences',
                image: 'assets/img/assistant-professor/ms-shalini-sharma-arni-school-of-allied-health-sciences.png',
            },
            {
                name: 'Ms. Sunita',
                designation: 'Assistant Professor, Mathematics Department',
                image: 'assets/img/assistant-professor/ms-sunita-assistant-professor-mathematics-department.png',
            },
            {
                name: 'Mr. Naresh Kumar',
                designation: 'Assistant Professor, (Electrical Engineering) Arni School of Technology',
                image: 'assets/img/assistant-professor/naresh-kumar-arni-school-of-technology-electrical-engineering.png',
            },
            {
                name: 'Mr. Rahul Kumar',
                designation: 'Assistant Professor, Arni School of Law',
                image: 'assets/img/assistant-professor/rahul-kumar-arni-school-of-law-assistant-professor.png',
            },
            {
                name: 'Raies Ahmad Thoker',
                designation: 'Assistant Professor, (Department of Anesthesia and Operation Theatre) Arni School of Allied Health Sciences',
                image: 'assets/img/assistant-professor/raies-ahmed-thoker-arni-school-of-allied-health-sciences-department-of-anesthesia-and-operation-theatre-technology.png',
            },
            {
                name: 'Dr. Raman',
                designation: 'Assistant Professor, Arni School of Law',
                image: 'assets/img/assistant-professor/raman-arni-school-of-law-assistant-professor.png',
            },
            {
                name: 'Sameer Ahmed Mir',
                designation: 'Assistant Professor, (MLT Department) Arni School of Technology',
                image: 'assets/img/assistant-professor/sameer-ahmed-mir-arni-school-of-allied-health-sciences-department-mlt.png',
            },
            {
                name: 'Sandeep Kumar',
                designation: 'Assistant Professor, Arni School of Hotel Management and Tourism',
                image: 'assets/img/assistant-professor/sandeep-kumar-assistant-professor-hotel-manegement-and-tourism.png',
            },
            {
                name: 'Tahira Salaam',
                designation: 'Assistant Professor, Department of OT/AT',
                image: 'assets/img/assistant-professor/tahira-salaam-department-of-ot-at.png',
            },
            {
                name: 'Sameer Ahmad Mir',
                designation: 'Assistant Professor, MLT (Allied Health Sciences)',
                image: 'assets/img/assistant-professor/sameer-ahmad-mir-assistant-professor-mlt-allied-health-sciences.jpeg',
            },
            {
                name: 'Anayat Ali Dar',
                designation: 'Assistant Professor, OT/AT (Allied Health Sciences)',
                image: 'assets/img/assistant-professor/anayat-ali-dar-assistant-professor-ot-at.jpeg',
            },
            {
                name: ' Dr. Navjyoti Gupta',
                designation: 'Assistant Professor, Physiotherapy (Allied Health Sciences)',
                image: 'assets/img/assistant-professor/navjyoti-gupta-assistant-professor-physiotherapy.jpeg',
            },
            {
                name: 'Anjali',
                designation: 'Assistant Professor, Pharmacy',
                image: 'assets/img/assistant-professor/anjali-assistant-professor-pharmacy.jpeg',
            },
            {
                name: 'Deepika',
                designation: 'Assistant Professor, Computer Science & Engineering',
                image: 'assets/img/assistant-professor/deepika-assistant-professor-cse.jpeg',
            },
            {
                name: 'Mrs. Anjna Devi',
                designation: 'Assistant Professor, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/mrs-anjna-devi-assistant-professor.png',
            },
            {
                name: 'Mrs. Samiksha Sharma',
                designation: 'Assistant Professor, English Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/mrs-samiksha-sharma-english-assistant-professor.png',
            },
            {
                name: 'Ms. Shavnam Sharma',
                designation: 'Lecturer, Fashion Design Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/ms-shavnam-sharma-fashion-design-lecturer.png',
            },
            {
                name: 'Mrs Shama Rani',
                designation: 'Lecturer, Fashion Design Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/mrs-shama-rani-lecturer-fashion-design.png',
            },
            {
                name: 'Ms. Mamta Devi',
                designation: 'Teaching Assistant, Hindi Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/ms-mamta-devi-teaching-assistant.png',
            },
            {
                name: 'Ms. Juna Bibi',
                designation: 'Teaching Assistant, History Department, Arni School of Arts and Humanities',
                image: 'assets/img/school-wise-faculties/arni-school-of-arts-and-humaities/ms-juna-bibi-history-teaching-assistant.png',
            },
            {
                name: 'Ms. Sunita',
                designation: 'Assistant Professor, Mathematics Department, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/school-wise-faculties/arni-school-of-basic-sciences/ms-sunita-assistant-professor-mathematics.png',
            },
            {
                name: 'Ms. Pallavi',
                designation: 'Assistant Professor , Mathematics Department, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/school-wise-faculties/arni-school-of-basic-sciences/ms-pallavi-assistant-professor-mathematics.png',
            },
            {
                name: 'Mr. Rahul Kumar',
                designation: 'Assistant Professor, CSA, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/mr-rahul-kumar-assistant-professor-csa.png',
            },
            {
                name: 'Mr. Rishav',
                designation: 'Assistant Professor, CSA, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/rishav-assistant-professor-csa.png',
            },
            {
                name: 'Harjit Singh',
                designation: 'Assistant Professor, Electrical Engineering, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/harjit-singh-assistant-professor-electrical-engineering.png',
            },
            {
                name: 'Surjit Singh',
                designation: 'Assistant Professor, Mechanical Engineering, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/surjit-singh-assistant-professor-mechanical-engineering.png',
            },
            {
                name: 'Rohit Kumar',
                designation: 'Assistant Professor, Civil Engineering, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/rohit-kumar-civil-engineering-assistant-professor.png',
            },
            {
                name: 'Naresh Kumar',
                designation: 'Assistant Professor, Electrical Engineering, Arni School of Technology',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/naresh-kumar-assistant-professor-ee.png',
            },
            {
                name: 'Ankush Kumar',
                designation: 'Assistant Professor, ARNI School of Pharmacy',
                image: 'assets/img/school-wise-faculties/arni-school-of-pharmacy/ankush-kumar-assistant-professor.png',
            },
            {
                name: 'Ankush Sharma',
                designation: 'Assistant Professor, ARNI School of Pharmacy',
                image: 'assets/img/school-wise-faculties/arni-school-of-pharmacy/ankush-sharma-assistant-professor.png',
            },
        ],
        associate_professor: [
            {
                name: 'Dr. Ashish Kumar Sharma',
                designation: 'Associate Professor, Mathematics Department, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/associate-professor/dr-ashish-kumar-sharma-mathematics-department.png',
            },
            {
                name: 'Dr. Sudhir Kumar Pal',
                designation: 'Associate Professor, Arni School of Law',
                image: 'assets/img/associate-professor/dr-sudhir-kumar-pal-arni-school-of-law.png',
            },
        ],
        lecturer_tutor: [
            {
                name: 'Chandani Vaishnav',
                designation: 'Lecturer, Arni School of Hotel Management and Tourism',
                image: 'assets/img/lecturer/chandani-vaishnav-lecturer-hotel-management-and-tourism.png',
            },
        ],
        academic_associate: [
            {
                name: 'Ashish Kumar',
                designation: 'Academic Associate , (Mechanical Engineering) Arni School of Technology',
                image: 'assets/img/academic-associate/ashish-kumar-arni-school-of-technology-mechanical-engineering.png',
            },
            {
                name: 'Ms. Manjubala',
                designation: 'Academic Associate , Department of Mathematics, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/academic-associate/ms-manjubala-mathematics-department.png',
            },
        ],
        teaching_assistant: [
            {
                name: 'Ms. Laxmi',
                designation: 'Teaching Assistant , Physics Department, Arni School of Basic Sciences and Biotechnology',
                image: 'assets/img/school-wise-faculties/arni-school-of-basic-sciences/laxmi-teaching-assistant-physics.png',
            },
            {
                name: 'Ms. Jaspreet Kaur',
                designation: 'Teaching Assistant, CSA',
                image: 'assets/img/school-wise-faculties/arni-school-of-technology/ms-jaspreet-kaur-assistant-professor-csa.webp',
            },
        ]
    };
    advisoryBoard = [
        {
            name: 'Dr. Vedprakash Mishra',
            designation: 'Pro-Chancellor, DMIHER, Nagpur',
            image: 'https://img.freepik.com/free-photo/closeup-young-hispanic-man-casuals-studio_662251-600.jpg?uid=R193663779&ga=GA1.1.1565501237.1742492506&semt=ais_hybrid&w=740',
        },
        {
            name: 'Dr. M.C. Misra',
            designation: 'Former Director, AIIMS',
            image: 'https://img.freepik.com/free-photo/worldface-japanese-guy-white-background_53876-31202.jpg?uid=R193663779&ga=GA1.1.1565501237.1742492506&semt=ais_hybrid&w=740',
        },
        {
            name: 'Prof. Devi Singh',
            designation: 'Former Director, IIM-Lucknow',
            image: 'https://img.freepik.com/premium-photo/close-up-portrait-man-restaurant_1048944-24299165.jpg?uid=R193663779&ga=GA1.1.1565501237.1742492506&semt=ais_hybrid&w=740',
        },
        {
            name: 'Dr. R. P. Singh',
            designation: 'Provost Adani University Gujarat',
            image: 'https://img.freepik.com/free-photo/portrait-confident-serious-young-man_114579-79034.jpg?uid=R193663779&ga=GA1.1.1565501237.1742492506&semt=ais_hybrid&w=740',
        },
        {
            name: 'Prof. Ved Prakash',
            designation: 'Former Chairman, University Grants Commission (UGC)',
            image: 'https://img.freepik.com/free-photo/portrait-confident-serious-young-man_114579-79034.jpg?uid=R193663779&ga=GA1.1.1565501237.1742492506&semt=ais_hybrid&w=740',
        },
        {
            name: 'Justice Dr. Satish Chandra',
            designation: 'Former Judge, High Court Allahabad',
            image: 'https://img.freepik.com/free-photo/portrait-confident-serious-young-man_114579-79034.jpg?uid=R193663779&ga=GA1.1.1565501237.1742492506&semt=ais_hybrid&w=740',
        }
    ];
    workOnArniTabs = [
        {label: 'Why Choose Arni', key: 'why_choose_arni'},
        {label: 'Work @ Arni', key: 'work_at_arni'},
        {label: 'Research Jobs', key: 'research_jobs'},
    ];
    selectedWorkOnArni = 'why_choose_arni';
    workOnArni = {
        workOnArniTabData: [
            {
                title: "Faculty Recruitment 2025-26",
                description: "We are seeking candidates for full-time on-site Teaching roles for the post of Professor / Associate Professor / Assistant Professor.",
                viewDetails: "Click here to view details",
                applyLink: "Click here to Apply"
            },
            {
                title: "FACULTY RECRUITMENT FROM SOUTH INDIA | Professor | Associate Professor",
                description: "A full-time on-site Teaching role for the post of Professor / Associate Professor in Arni School of Engineering and Technology, Arni School of Business Studies and Arni School of Media, Film and Entertainment.",
                viewDetails: "Click here to view details",
                applyLink: "Click here to Apply"
            },
            {
                title: "Professors/Associate Professors/ Assistant Professors.",
                description: "Arni University is looking for people from academics with strong research background for the positions of Professors/Associate Professors/ Assistant Professors. Candidates with Ph.D will be given preference.",
                viewDetails: "Click here to view details",
                applyLink: "Click here to Apply"
            },
            {
                title: "Arni University is inviting applications for Non Academic positions",
                description: "Arni University is inviting applications for Non Academic positions.",
                viewDetails: "Click here to view details",
                applyLink: "Click here to Apply"
            },
            {
                title: "Professor of Practice",
                description: "Arni University invites applications for the positions of Professor of Practice.",
                viewDetails: "Click here to view details",
                applyLink: "Click here to Apply"
            },
            {
                title: "Arni University Hiring Research Professor specialized in Quantum Computing",
                description: "Interested and eligible candidates are encouraged to complete the application form using the provided link.",
                viewDetails: "Click here to view details",
                applyLink: "Click here to Apply"
            }
        ],
        researchJobs: [
            {
                title: "ADVERTISEMENT FOR JRF POSITION-DRDO",
                description: "Applications are invited from Indian Nationals for the position of Junior Research Fellow (JRF) under a DRDO-funded project.",
            },
            {
                title: "ADVERTISEMENT OF PROJECT STAFF",
                description: "Advertisement for “Walk-in Interview” on 1st March 2025 for the project staff under ICMR funded project. Applications are invited for the following contractual appointment post in the following ICMR funded project in Department of Life Sciences, Sharda School of Basic Sciences & Research, Sharda University, Greater Noida-201310, India.",

            },
            {
                title: "ADVERTISEMENT FOR RESEARCH ASSISTANT (RA)",
                description: "Applications are invited from Indian citizens who are residents of Uttar Pradesh for the post of Research Assistant (RA) (on contract) in Department of Computer Science & Engineering CSE), Sharda University, Greater Noida,Greater Noida-201310, India.",
            },
        ],
    }

    constructor(private route: ActivatedRoute,
                private router: Router,
                private fb: FormBuilder,
                private sanitizer: DomSanitizer) {
        this.route.data.subscribe(params => {
            this.pageTitle = params['title'];
        })
    }

    ngOnInit(): void {
        window.scrollTo(0, 0);
        this.refresh()
        this.onTabChange('all')
    }

    refresh() {
        this.searchForm = this.fb.group({
            search_key: [''],
        })

        const defaultTab = this.selectedTab || 'all';
        this.onTabChange(defaultTab);
    }

    goTo(section: string) {
        this.router.navigateByUrl(section);
    }

    toggleAccordion(index: number): void {
        if (this.activeIndex === index) {
            this.activeIndex = null;
        } else {
            this.activeIndex = index;
        }
    }

    openInNewTab(pdfUrl: string): void {
        window.open(pdfUrl, '_blank');
    }

    openPdfModal(pdfUrl: string) {
        this.selectedPdf = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
    }

    closePdfModal() {
        this.selectedPdf = null;
    }

    onTabChange(tabKey: string) {
        this.selectedTab = tabKey;
        this.filteredFacultyList = [...this.facultyData?.[tabKey] || []];
        this.onSearch();
    }

    onSearch() {
        const searchValue = this.searchForm?.get('search_key')?.value?.toLowerCase().trim() || '';
        const list = this.selectedTab === 'all'
            ? Object.values(this.facultyData || {}).flat()
            : this.facultyData?.[this.selectedTab] || [];
        const filtered = searchValue
            ? list.filter((f: any) =>
                f.name.toLowerCase().includes(searchValue)
            )
            : [...list];
        this.filteredFacultyList = filtered.filter(
            (item, index, self) =>
                index === self.findIndex((t) => t.name === item.name)
        );
    }

    /*onTabChange(tabKey: string) {
        this.selectedTab = tabKey;
        this.filteredFacultyList = [...this.facultyData?.[tabKey] || []];
    }

    onSearch() {
        const searchValue = this.searchForm?.get('search_key')?.value?.toLowerCase().trim() || '';
        const list = this.selectedTab === 'all' ? Object.values(this.facultyData || {}).flat() : this.facultyData?.[this.selectedTab] || [];

        this.filteredFacultyList = searchValue ? list.filter((f: any) => f.name.toLowerCase().includes(searchValue)) : [...list];
    }*/


    getImageSrc(): string {
        switch (this.pageTitle) {
            case 'About Us':
                return "./assets/img/about/overview-&-identity-about-us.webp";
            case 'Core Values':
                return "./assets/img/about/core-values-about-us.webp";
            case 'Mission And Vision':
                return "./assets/img/about/Vission-&-mission-about-us.webp";
            case 'History':
                return "./assets/img/about/history-about-us.webp";
            case 'Advisory Board':
                return "./assets/img/about/arni-group-about-us.webp";
            case 'Work At Arni':
                return "./assets/img/about/work-with-arni-about-us.webp";
            case 'Government Affiliations':
                return "./assets/img/about/government-affiliations-about-us.webp";
            case 'Statutory Bodies Of The University':
                return "./assets/img/about/statutory-bodies-of-the-university.webp";
            case 'Ai Integrated Program':
                return "./assets/img/about/ai-integrated-program.webp";
            default:
                return "./assets/img/about/overview-&-identity-about-us.webp";
        }
    }

    getImageForPhoneView(): string {
        switch (this.pageTitle) {
            case 'About Us':
                return "./assets/img/about/mobile-banner/overview-&-identity-about-us.webp";
            case 'Core Values':
                return "./assets/img/about/mobile-banner/core-values-about-us.webp";
            case 'Mission And Vision':
                return "./assets/img/about/mobile-banner/Vission-&-mission-about-us.webp";
            case 'History':
                return "./assets/img/about/mobile-banner/history-about-us.webp";
            case 'Advisory Board':
                return "./assets/img/about/mobile-banner/arni-group-about-us.webp";
            case 'Work At Arni':
                return "./assets/img/about/mobile-banner/work-with-arni-about-us.webp";
            case 'Government Affiliations':
                return "./assets/img/about/mobile-banner/government-affiliations-about-us.webp";
            case 'Statutory Bodies Of The University':
                return "./assets/img/about/mobile-banner/statutory-bodies-of-the-university.webp";
            case 'Ai Integrated Program':
                return "./assets/img/about/mobile-banner/ai-integrated-program.webp";
            default:
                return "./assets/img/about/mobile-banner/overview-&-identity-about-us.webp";
        }
    }

    getImgForMediumScreen() {
        switch (this.pageTitle) {
            case 'About Us':
                return "./assets/img/about/medium-screen-banner/overview-&-identity-about-us.webp";
            case 'Core Values':
                return "./assets/img/about/medium-screen-banner/core-values-about-us.webp";
            case 'Mission And Vision':
                return "./assets/img/about/medium-screen-banner/Vission-&-mission-about-us.webp";
            case 'History':
                return "./assets/img/about/medium-screen-banner/history-about-us.webp";
            case 'Advisory Board':
                return "./assets/img/about/medium-screen-banner/arni-group-about-us.webp";
            case 'Work At Arni':
                return "./assets/img/about/medium-screen-banner/work-with-arni-about-us.webp";
            case 'Government Affiliations':
                return "./assets/img/about/medium-screen-banner/government-affiliations-about-us.webp";
            case 'Statutory Bodies Of The University':
                return "./assets/img/about/medium-screen-banner/statutory-bodies-of-the-university.webp";
            case 'Ai Integrated Program':
                return "./assets/img/about/medium-screen-banner/ai-integrated-program.webp";
            default:
                return "./assets/img/about/medium-screen-banner/overview-&-identity-about-us.webp";
        }
    }
}
